import React from 'react';
import PhoneInput from 'react-phone-input-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { Controller } from 'react-hook-form';
import FormIcon from './FormIcon';
import 'react-phone-input-2/lib/material.css';
import './phone-input.css';

export default function FormPhoneInput({
  error,
  validation,
  isOpenForm,
  handleFocus,
}) {
  return (
    <div className={`relative inline-block ${error ? 'pb-4' : ''}`}>
      <Controller
        name="phone"
        render={({ field }) => (
          <PhoneInput
            country="in"
            placeholder="Phone"
            name="phone"
            className="hire-from-crio-form"
            countryCodeEditable={false}
            onFocus={handleFocus}
            defaultErrorMessage={error}
            isValid={() => {
              if (typeof window !== 'undefined' && document) {
                error
                  ? document.documentElement.style.setProperty(
                      '--phone-input-color',
                      '#F3736A',
                    )
                  : document.documentElement.style.setProperty(
                      '--phone-input-color',
                      '#7A8B87',
                    );
              }
              return error ? false : true;
            }}
            inputProps={{
              required: true,
            }}
            inputStyle={{
              width: '100%',
              color: '#7A8B87',
              ...(error
                ? { background: '#4D3230' }
                : { background: '#F9F8F7' }),
              border: 'none',
              outline: 'none',
            }}
            {...field}
          />
        )}
      ></Controller>
      <FormIcon
        icon={<FontAwesomeIcon icon={faPhone} />}
        error={error}
        validated={validation}
      />
    </div>
  );
}
